import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    stepIndex: 0,
    applyJob: {},
    bianzhi: '',
    signup_id: '',
    passInfo: true, // true：提交报名表单正在审核， false: 审核未通过
    payInfo: true, // true：缴费正在审核， false: 审核未通过
    payHerf: '',
    recId: '',
    registration: '',
    failInfo: '',
    downLoadHerf: ''
  },
  mutations: {
    ADD_STEP: state => {
      state.stepIndex++
    },
    RESET_STEP: state => {
      state.stepIndex = 2
    },
    SET_ApplyJob: (state, info) => {
      state.applyJob = info
    },
    SET_BIANZHI: (state, val) => {
      state.bianzhi = val
    },
    SET_SINGUPID: (state, val) => {
      state.signup_id = val
    },
    SET_STEP: (state, val) => {
      state.stepIndex = val
    },
    SET_PASS: (state, val) => {
      state.passInfo = val
    },
    SET_PAY: (state, val) => {
      state.payInfo = val
    },
    SET_PAYHERF: (state, val) => {
      state.payHerf = val
    },
    SET_RECID: (state, val) => {
      state.recId = val
      window.sessionStorage.setItem('recId', val)
    },
    SET_REGISTRATION: (state, val) => {
      state.registration = val
      window.sessionStorage.setItem('registration', val)
    },

    SET_FAILINFO: (state, val) => {
      state.failInfo = val
    },
    SET_DOWNLOAD: (state, val) => {
      state.downLoadHerf = val
    }
  },
  actions: {},
  modules: {}
})
